// Partners.jsx
import React from "react";
import Client1 from "../Assets/Images/client-1.jpeg";
import Client2 from "../Assets/Images/client-2.jpg";
import Client3 from "../Assets/Images/client-3.jpg";
import Client4 from "../Assets/Images/client-4.jpeg";
import Client5 from "../Assets/Images/client-5.jpeg";
import Client6 from "../Assets/Images/client-6.jpeg";
import Client7 from "../Assets/Images/Client7.jpeg";
import Client8 from "../Assets/Images/Client-8.png";
import Client9 from "../Assets/Images/client-9.png";
import Client10 from "../Assets/Images/client-10.jpeg";
import Client11 from "../Assets/Images/client-11.jpeg";
import Client12 from "../Assets/Images/client-12.jpeg";
import Client13 from "../Assets/Images/client-13.jpeg";
import Client14 from "../Assets/Images/client-14.png";
import Client15 from "../Assets/Images/client-15.png";
import Client16 from "../Assets/Images/client-16.png";
import Client17 from "../Assets/Images/client-17.jpeg";
import Client18 from "../Assets/Images/client-18.jpeg";
import Client19 from "../Assets/Images/client-19.png";
import Client20 from "../Assets/Images/TNHMWA.png";
import Client21 from "../Assets/Images/client-21.jpg";
import Client22 from "../Assets/Images/client-22.png";
import Client23 from "../Assets/Images/client-23.jpeg";


const Partners = () => {
  const logos = [
    Client1, Client2, Client3, Client4, Client5, Client6, Client7,
    Client8, Client9, Client10, Client11, Client12, Client13, Client14,
    Client15, Client16, Client17, Client18, Client19,Client20, Client21, Client22, Client23
  ];

  // For row 1: normal order → Client1 to Client19
  const forwardLogos = [...logos, ...logos, ...logos];

  // For row 2: reverse order → Client19 to Client1
  const reverseLogos = [...logos].reverse();           // single reverse
  const repeatedReverse = [...reverseLogos, ...reverseLogos, ...reverseLogos];

  return (
    <section className="py-16 md:py-20 lg:py-24 bg-gradient-to-b from-black/40 to-black/10">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <h3 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white text-center mb-12 md:mb-16 tracking-tight">
          Partners Who Trust Us
        </h3>

        {/* Row 1 – scrolling left – normal order */}
        <div className="relative overflow-hidden mb-10 md:mb-12">
          <div
            className={`
              flex items-center gap-10 sm:gap-12 md:gap-16 lg:gap-20
              animate-scroll-partners lg:animate-scroll-partners-lg
              will-change-transform
              hover:pause-scroll
            `}
          >
            {forwardLogos.map((logo, idx) => (
              <div
                key={idx}
                className="
                  flex-shrink-0 transition-all duration-300
                  hover:scale-110 hover:drop-shadow-[0_0_12px_rgba(255,255,255,0.25)]
                "
              >
                <img
                  src={logo}
                  alt={`Partner logo ${idx + 1}`}
                  className="h-10 sm:h-12 md:h-14 lg:h-16 w-auto max-w-[140px] object-contain"
                  loading="lazy"
                />
              </div>
            ))}
          </div>

          {/* Fade masks */}
          <div className="pointer-events-none absolute inset-y-0 left-0 w-16 sm:w-24 md:w-32 lg:w-56 bg-gradient-to-r from-black to-transparent" />
          <div className="pointer-events-none absolute inset-y-0 right-0 w-16 sm:w-24 md:w-32 lg:w-56 bg-gradient-to-l from-black to-transparent" />
        </div>

        {/* Row 2 – scrolling right – REVERSE order */}
        <div className="relative overflow-hidden">
          <div
            className={`
              flex items-center gap-10 sm:gap-12 md:gap-16 lg:gap-20
              animate-scroll-partners-reverse lg:animate-scroll-partners-reverse-lg
              will-change-transform
              hover:pause-scroll
            `}
          >
            {repeatedReverse.map((logo, idx) => (
              <div
                key={`rev-${idx}`}
                className="
                  flex-shrink-0 transition-all duration-300
                  hover:scale-110 hover:drop-shadow-[0_0_12px_rgba(255,255,255,0.25)]
                "
              >
                <img
                  src={logo}
                  alt={`Partner logo ${logos.length - (idx % logos.length)}`}
                  className="h-10 sm:h-12 md:h-14 lg:h-16 w-auto max-w-[140px] object-contain"
                  loading="lazy"
                />
              </div>
            ))}
          </div>

          <div className="pointer-events-none absolute inset-y-0 left-0 w-16 sm:w-24 md:w-32 lg:w-56 bg-gradient-to-r from-black to-transparent" />
          <div className="pointer-events-none absolute inset-y-0 right-0 w-16 sm:w-24 md:w-32 lg:w-56 bg-gradient-to-l from-black to-transparent" />
        </div>
      </div>
    </section>
  );
};

export default Partners;